import { render, staticRenderFns } from "./mineResource.vue?vue&type=template&id=ac5d9586&scoped=true&"
import script from "./mineResource.vue?vue&type=script&lang=js&"
export * from "./mineResource.vue?vue&type=script&lang=js&"
import style0 from "./mineResource.vue?vue&type=style&index=0&id=ac5d9586&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5d9586",
  null
  
)

export default component.exports